import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/shadcn/Tooltip/Tooltip";
import { CircleAlert } from "lucide-react";

export function SignerFieldsWarning({ kind }: { kind: "contact" | "user" }) {
  const message = `This ${kind} has 0 signer fields`;
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            role="img"
            aria-label={message}
            className="inline-flex shrink-0 text-yellow-600"
          >
            <CircleAlert className="h-4 w-4" aria-hidden />
          </span>
        </TooltipTrigger>
        <TooltipContent>{message}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
